import Repository from "@/utils/API/Repository";

export const resource = '/system';

export default {
  getBuildVersion() {
    return Repository.get(
      `${resource}/BuildVersion`,
      { withCredentials: true }
    );
  }
};